import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [leftMenuOpen, setLeftMenuOpen] = useState(false);
  const [rightMenuOpen, setRightMenuOpen] = useState(false);
  const [nameHovered, setNameHovered] = useState(false);
  const [cvLink, setCvLink] = useState(null);
  const [loadingCv, setLoadingCv] = useState(false);
  const navbarRef = useRef(null);

  // قائمة بالخطوط العربية الجميلة
  const arabicFonts = [
    "'El Messiri', sans-serif",
    // "'Amiri', serif",
    // "'Lalezar', cursive",
    // "'Scheherazade New', serif",
    // "'Tajawal', sans-serif",
    // "'Noto Naskh Arabic', serif",
    // "'Lateef', cursive",
    // "'Mirza', cursive",
  ];

  const [currentFont, setCurrentFont] = useState(arabicFonts[0]);

  // جلب رابط السيرة الذاتية عند تحميل المكون
  useEffect(() => {
    const fetchCV = async () => {
      try {
        setLoadingCv(true);
        const response = await fetch('https://my-portfoli-backed.onrender.com/api/cv');
        if (!response.ok) {
          throw new Error('Failed to fetch CV');
        }
        const data = await response.json();
        if (data.cvs && data.cvs.length > 0) {
          setCvLink(data.cvs[0].downloadLink);
        }
      } catch (error) {
        console.error('Error fetching CV:', error);
      } finally {
        setLoadingCv(false);
      }
    };

    fetchCV();
  }, []);

  // إغلاق القوائم عند النقر خارجها
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setLeftMenuOpen(false);
        setRightMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleDownloadCV = (e) => {
    e.preventDefault();
    if (cvLink) {
      window.open(cvLink, '_blank');
    } else {
      alert('السيرة الذاتية غير متاحة حالياً. يرجى المحاولة لاحقاً.');
    }
    setLeftMenuOpen(false);
  };

  const navbarStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1.5rem 5%',
    backgroundColor: 'white',
    color: 'black',
    position: 'sticky',
    top: '0',
    zIndex: '1000',
    boxShadow: '0 2px 15px rgba(0,0,0,0.05)',
    borderBottom: '1px solid #f0f0f0',
    maxWidth: '100%',
    margin: '0 auto',
  };

  const menuIconStyle = {
    fontSize: '1.8rem',
    cursor: 'pointer',
    padding: '0.5rem',
    color: 'black',
    transition: 'transform 0.3s ease',
    ':hover': {
      transform: 'scale(1.1)',
    }
  };

  const nameStyle = {
    fontSize: '1.8rem',
    fontWeight: '700',
    color: 'black',
    position: 'relative',
    padding: '0 1rem',
    fontFamily: currentFont,
    transition: 'all 0.5s ease',
    transform: nameHovered ? 'scale(1.05)' : 'scale(1)',
    '::after': {
      content: '""',
      position: 'absolute',
      bottom: '-5px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: nameHovered ? '80%' : '30px',
      height: '2px',
      backgroundColor: 'black',
      transition: 'all 0.3s ease',
    }
  };

 const dropdownStyle = {
  position: 'absolute',
  top: 'calc(100% + 5px)',
  backgroundColor: 'white',
  boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
  zIndex: '1000',
  padding: '0.5rem 0',
  borderRadius: '8px',
  left: '0',        // ← غيّر من right إلى left
  right: 'auto',    // ← أضف هذا
  display: leftMenuOpen ? 'block' : 'none',
  minWidth: '180px',
  border: '1px solid #f0f0f0',
};

const dropdownRightStyle = {
  ...dropdownStyle,
  left: 'auto',     // ← غيّر
  right: '0',       // ← غيّر
  display: rightMenuOpen ? 'block' : 'none',
};
  const dropdownItemStyle = {
    padding: '0.75rem 1.5rem',
    display: 'block',
    textDecoration: 'none',
    color: '#333',
    transition: 'all 0.2s ease',
    fontWeight: '500',
    ':hover': {
      backgroundColor: '#f8f8f8',
      color: 'black',
      paddingLeft: '1.75rem',
    }
  };

  const menuContainerStyle = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  };

  const changeFont = () => {
    const currentIndex = arabicFonts.indexOf(currentFont);
    const nextIndex = (currentIndex + 1) % arabicFonts.length;
    setCurrentFont(arabicFonts[nextIndex]);
  };

return (
   <div style={navbarStyle} ref={navbarRef}>

  {/* 1. أول شيء = يمين الشاشة */}
  {/* بطاقة الصورة + الاسم */}
  <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '10px' }}>
    <img 
      src="/images/me.png" 
      alt="عبدالرحمن"
      style={{ width: '46px', height: '46px', borderRadius: '50%', objectFit: 'cover', border: '1.5px solid #e5e5e5' }}
      onError={(e) => { e.target.style.display = 'none'; }}
    />
    <div style={{ textAlign: 'right' }}>
      <div style={{ fontSize: '14px', fontWeight: '600', color: '#000', fontFamily: "'Tajawal', sans-serif" }}>عبدالرحمن</div>
      <div style={{ fontSize: '11px', color: '#666', fontFamily: "'Tajawal', sans-serif" }}>Full-Stack Developer</div>
    </div>
  </Link>

  {/* 2. المنتصف = الاسم */}
  {/* <Link to="/" style={{ textDecoration: 'none' }}
    onClick={(e) => { e.preventDefault(); changeFont(); }}
    onMouseEnter={() => setNameHovered(true)}
    onMouseLeave={() => setNameHovered(false)}
  >
    <div style={nameStyle}>-_-</div>
  </Link> */}

  {/* 3. آخر شيء = يسار الشاشة — القائمتان جنب بعض */}
  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>

    {/* ••• */}
    <div style={menuContainerStyle}>
      <div 
        style={{
          ...menuIconStyle,
          width: '40px', height: '40px', borderRadius: '50%',
          display: 'flex', justifyContent: 'center', alignItems: 'center',
          backgroundColor: leftMenuOpen ? '#f5f5f5' : 'transparent',
        }}
        onClick={(e) => { e.stopPropagation(); setLeftMenuOpen(!leftMenuOpen); setRightMenuOpen(false); }}
      >
        <span style={{ fontSize: '1.2rem' }}>•••</span>
      </div>
      <div style={dropdownStyle}>
        <Link to="/contact" style={dropdownItemStyle} onClick={() => setLeftMenuOpen(false)}>طرق التواصل</Link>
        <Link to="/faq" style={dropdownItemStyle} onClick={() => setLeftMenuOpen(false)}>الاسئلة الشائعة</Link>
        <Link to="/support" style={dropdownItemStyle} onClick={() => setLeftMenuOpen(false)}>خدمة الدعم</Link>
        <a href="#" style={dropdownItemStyle} onClick={handleDownloadCV}>
          {loadingCv ? 'جاري التحميل...' : 'تحميل السيرة الذاتية (CV)'}
        </a>
        <Link to="/clients" style={dropdownItemStyle} onClick={() => setLeftMenuOpen(false)}>عملائي</Link>
      </div>
    </div>

    {/* ☰ */}
    <div style={menuContainerStyle}>
      <div 
        style={{
          ...menuIconStyle,
          width: '40px', height: '40px', borderRadius: '50%',
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '5px',
          backgroundColor: rightMenuOpen ? '#f5f5f5' : 'transparent',
        }}
        onClick={(e) => { e.stopPropagation(); setRightMenuOpen(!rightMenuOpen); setLeftMenuOpen(false); }}
      >
        <div style={{ width: '20px', height: '2px', backgroundColor: 'black', transform: rightMenuOpen ? 'rotate(45deg) translate(4px, 4px)' : 'none', transition: 'transform 0.3s ease' }}></div>
        <div style={{ width: '20px', height: '2px', backgroundColor: 'black', opacity: rightMenuOpen ? '0' : '1', transition: 'opacity 0.3s ease' }}></div>
        <div style={{ width: '20px', height: '2px', backgroundColor: 'black', transform: rightMenuOpen ? 'rotate(-45deg) translate(4px, -4px)' : 'none', transition: 'transform 0.3s ease' }}></div>
      </div>
      <div style={{ ...dropdownRightStyle, left: '0 ', right: 'auto' }}>
        <Link to="/projects" style={dropdownItemStyle} onClick={() => setRightMenuOpen(false)}>أعمالي</Link>
        <Link to="/blogs" style={dropdownItemStyle} onClick={() => setRightMenuOpen(false)}>مدوناتي</Link>
        <Link to="/books" style={dropdownItemStyle} onClick={() => setRightMenuOpen(false)}>كتبي</Link>
      </div>
    </div>

  </div>

</div>
  );
};

export default Navbar;